import React from 'react'

const CartContext = React.createContext({
  isDarkTheme: false,
  savedVideos: [],
  addToSaveVideos: () => {},
  onChangeTheme: () => {},
  activeTab: '',
  activeTabItem: () => {},
  removeSavedVideos: () => {},
})

export default CartContext
